// TODO: anything imported here should be moved to shared modules (eg all campaign agents)
import {copilot, users as usersShared} from '@cl/shared';
import campaignAnalyticsAgent from 'common/src/modules/analytics/copilot/agents/campaignAnalyticsAgent/campaignAnalyticsAgent';
import campaignSetupAgent from 'common/src/modules/campaigns/copilot/agents/campaignSetupAgent/campaignSetupAgent';
import excelToCampaignAgent from 'common/src/modules/campaigns/copilot/agents/excelToCampaignAgent/excelToCampaignAgent';
import strategyAgent from 'common/src/modules/campaigns/copilot/agents/strategyAgent';
import fetchCampaigns from 'common/src/modules/campaigns/store/campaignsLibrary/thunks/fetchCampaigns';
import {FeatureFlagKey} from 'common/src/modules/featureFlags/featureFlags.types';
import isFlagEnabled from 'common/src/modules/featureFlags/utils/isFlagEnabled';
import {doesUserHaveRole} from 'common/src/modules/roles/utils/doesUserHaveRole';
import socialCampaignSetupAgent from 'common/src/modules/social/copilot/agents/socialCampaignSetupAgent/socialCampaignSetupAgent';
import {RoleTypeName} from 'common/src/modules/users/users.types';
import {CLStore} from 'common/src/redux/store';

async function initializeCampaignsAgents(store: CLStore) {
  //pre-load campaigns before initializing campaign agents
  if (store.getState().campaignsLibrary.campaigns.length === 0) {
    await store.dispatch(fetchCampaigns());
  }

  if (isFlagEnabled(FeatureFlagKey.EnableCopilotCampaignsManagerAgent)) {
    const userHasCampaignsWriteRole = doesUserHaveRole(
      usersShared.userSubject.data,
      RoleTypeName.CampaignsWrite,
    );

    if (
      isFlagEnabled(FeatureFlagKey.EnableCopilotExcelToCampaignAgent) &&
      userHasCampaignsWriteRole
    ) {
      copilot.registerAgent(excelToCampaignAgent(store));
    }

    if (isFlagEnabled(FeatureFlagKey.EnableCopilotCampaignAnalyticsAgent)) {
      copilot.registerAgent(campaignAnalyticsAgent(store));
    }

    if (isFlagEnabled(FeatureFlagKey.EnableCopilotCampaignSetupAgent)) {
      copilot.registerAgent(campaignSetupAgent(store));
    }

    if (isFlagEnabled(FeatureFlagKey.EnableCopilotSocialCampaignSetupAgent)) {
      copilot.registerAgent(socialCampaignSetupAgent(store));
    }

    if (isFlagEnabled(FeatureFlagKey.EnableCopilotBriefAndStrategyAgents)) {
      copilot.registerAgent(strategyAgent(store));
    }
  }
}

export default initializeCampaignsAgents;
